import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { ProjectInfo } from '@company-common/config/ProjectInfo'

@Module({
  namespaced: true
})
export default class KYCSectionStore extends VuexModule {
  private projectInfo = new ProjectInfo()
  private totalUploadedPdf = []

  sections: { name: string; url?: string; completed?: boolean; allowed?: boolean; subs?: any[]; hideIndicator?: boolean }[] = [
    { name: 'Client Summary', url: 'client-summary', completed: false, allowed: true }, // url empty as default
    { name: 'Important Notices', url: 'important-notices', completed: false, allowed: true },
    {
      name: 'About You',
      url: 'about-you',
      completed: false,
      subs: [
        { name: 'Personal Details', url: 'personal-details', completed: false },
        { name: 'Dependants', url: 'dependants', completed: false },
        { name: 'Trusted Individual', url: 'trusted-individual', completed: false }
      ],
      allowed: false
    },
    {
      name: 'Your Current Plans',
      url: 'current-portfolio',
      completed: false,
      subs: [
        { name: 'Insurance Portfolio', url: 'insurance', completed: false },
        { name: 'Investment Portfolio', url: 'investment', completed: false }
      ],
      allowed: false
    },
    {
      name: 'Your Finances',
      url: 'your-finances',
      completed: false,
      subs: [
        { name: 'Net Worth', url: 'net-worth', completed: false },
        { name: 'Cash Flow', url: 'cash-flow', completed: false },
        { name: 'Budget', url: 'budget', completed: false }
      ],
      allowed: false
    },
    {
      name: 'Your Investment Risk Profile',
      url: 'investment-risk-profile',
      completed: false,
      subs: [
        { name: 'Customer Knowledge Assessment', url: 'customer-knowledge-assessment', completed: false },
        { name: 'Risk Profile Assessment', url: 'risk-profile-assessment', completed: false }
      ],
      allowed: false
    },
    {
      name: 'Your Priorities & Needs Analysis',
      url: 'needs-analysis',
      completed: false,
      subs: [
        { name: 'Adjustments & Assumptions', url: 'adjustments-and-assumptions', completed: false },
        { name: 'Identifying Your Priorities', url: 'identifying-your-priorities', completed: false },
        { name: 'Needs Analysis Calculation', url: 'needs-analysis-calculation', completed: false }
      ],
      allowed: false
    },
    {
      name: 'Our Recommendation',
      url: 'our-recommendation',
      completed: false,
      subs: [
        { name: 'Product Recommendations', url: 'product-recommendations', completed: false },
        { name: 'For Investments - ILP/Sub funds', url: 'ilp-sub-funds', completed: false },
        { name: 'Basis of Recommendation', url: 'basis-of-recommendation', completed: false },
        { name: 'Client\'s Decision', url: 'client-decision', completed: false }
      ],
      allowed: false
    },
    { name: 'Replacement / Switching', url: 'replacement-or-switching', completed: false, allowed: false },
    { name: 'Disclaimers & Client\'s Checklist', url: 'disclaimers-and-client-checklist', completed: false, allowed: false },
    { name: 'Client\'s Declaration', url: 'client-declaration', completed: false, allowed: false },
    { name: 'Financial Adviser\'s Declaration', url: 'financial-consultant-declaration', completed: false, allowed: false },
    { name: 'KYC Confirmation', url: 'kyc-confirmation', completed: false, allowed: false },
    { name: 'space' },
    { name: 'Beneficial Owner Particulars Form', url: 'bop', completed: false, allowed: false },
    { name: 'Politically Exposed Person Form', url: 'pep', completed: false, allowed: false },
    { name: 'Client\'s AML Check', url: 'aml', completed: false, allowed: false },
    { name: 'Appendix - Upload PDFs', url: 'appendix', completed: true, allowed: true, hideIndicator: true }
  ]

  @Mutation
  updateTotalUploadedPdf (list: []) {
    this.totalUploadedPdf = list
  }

  @Mutation
  hideSection (url: string) {
    this.sections = this.sections.filter(sec => sec.url !== url)
  }
}
